module.exports = parcelRequire.resolve("jQ7Bt");